;(function (angular, _) {
  'use strict'

  angular
    .module('kilo.common.directives')
    .directive('displayCustomFields', displayCustomFieldsDirective)

  DisplayCustomFieldsController.$inject = ['$scope', 'DatePickerService']

  function DisplayCustomFieldsController ($scope, DatePickerService) {
    var self = this

    self.$onInit = () => {
      _.extend(self, {
        // Public Attributes
        // Public Methods
        getMinValue: getMinValue,
        getMaxValue: getMaxValue,
        removeFile: removeFile,
        setDate: setDate,
        resetDate: resetDate,
        validate: validate,
        setChecked: setChecked
      })
    }

    $scope.$watch(function () {
      if (!self.edit) {
        return
      } else {
        self.customFields.forEach(field => {
          switch (field.type) {
            case 'File':
            case 'String':
            case 'Select':
            case 'Date':
            case 'Number':
              if (field.options.required && !self.model[field.key]) {
                field.required = true
              } else {
                field.required = false
              }
              break
            case 'Boolean':
              break
          }
        })
      }
      self.customFields.forEach(field => {
        if (field.type === 'Select' && !field.options.options && Array.isArray(field.options.values)) {
          field.options.options = field.options.values
          field.options.values = null
        }
      })
      for (const property in self.model) {
        if ([undefined, null, '-'].includes(self.model[property])) {
          self.model[property] = null
        }
      }
      return self.model
    }, function () {
      initDate()
    })

    initDate()
    initSelectOptions()

    function initSelectOptions () {
      if (self.model) {
        self.customFields.forEach(function (field) {
          if (field.type === 'Select' && field.options.options) {
            field.options.options.unshift(...'-')
          }
        })
      }
    }

    function initDate () {
      if (self.model) {
        self.customFields.forEach(function (field) {
          if (field.type === 'Date') {
            if (self.model[field.key]) self.model[field.key] = new Date(self.model[field.key])
          }
        })
      }
    }

    function setChecked (field) {
      self.model[field.key] = !self.model[field.key]
      $scope.$emit('formModified')
    }

    function setDate (key) {
      if (!self.edit) return
      DatePickerService.getRange(self.model[key]).then(function (date) {
        self.model[key] = new Date(date)
        $scope.$emit('formModified')
      })
    }

    function resetDate (key) {
      delete self.model[key]
      $scope.$emit('formModified')
    }

    function removeFile (key, item) {
      self.model[key] = _.filter(self.model[key], function (f) {
        return f._id !== item._id
      })
    }

    function getMinValue (field) {
      if (field.options && field.options.min) return field.options.min
    }

    function getMaxValue (field) {
      if (field.options && field.options.max) return field.options.max
    }

    function validate (field) {
      if (isNaN(self.model[field.key])) {
        delete self.model[field.key]
      }
    }
  }

  displayCustomFieldsDirective.$inject = [ ]

  function displayCustomFieldsDirective () {
    return {
      restrict: 'E',
      scope: {},
      bindToController: {
        customFields: '=',
        edit: '=',
        model: '='
      },
      transclude: true,
      controller: DisplayCustomFieldsController,
      controllerAs: 'ctrl',
      templateUrl: '/app/common/directives/display-custom-fields/display-custom-fields.template.html'
    }
  }
})(window.angular, window._)
